import type ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { RecipientExpansionStatus } from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getDisplayTextFromEmailAddress from 'owa-recipient-email-address/lib/utils/getDisplayTextFromEmailAddress';
import isValidRecipient from 'owa-recipient-email-address/lib/utils/isValidRecipient';
import { nextRecipientKey } from 'owa-recipient-common/lib/utils/nextRecipientKey';

type ReadWriteRecipientViewStateWithoutPersona = Omit<
    ReadWriteRecipientViewState,
    'persona' | 'isPendingResolution'
>;

export const baseViewState: Omit<
    ReadWriteRecipientViewStateWithoutPersona,
    'editKey' | 'isValid' | 'displayText'
> = {
    isContextMenuOpen: false,
    isSelected: false,
    isExpanding: false,
    isEditing: false,
    isFadedOut: false,
    expansionStatus: RecipientExpansionStatus.None,
    members: [],
};

export function getPartialReadWriteRecipientViewStateFromEmailAddress(
    emailAddress: EmailAddressWrapper,
    explicitDisplayName?: string
): ReadWriteRecipientViewStateWithoutPersona {
    return {
        ...baseViewState,
        editKey: nextRecipientKey(),
        isValid: isValidRecipient(emailAddress),
        displayText: getDisplayTextFromEmailAddress(emailAddress, explicitDisplayName),
    };
}
